import React from 'react';

export const Paperclip: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width || '1em'} height={height || '1em'} viewBox="0 0 128 128">
        <path fill={color || 'currentColor'} d="M64,23.767A20.606,20.606,0,0,0,43.417,44.35V89.566a14.667,14.667,0,1,0,29.333,0V46.25a8.75,8.75,0,0,0-17.5,0V87.5a1.75,1.75,0,0,0,3.5,0V46.25a5.25,5.25,0,0,1,10.5,0V89.566a11.167,11.167,0,1,1-22.333,0V44.35a17.083,17.083,0,0,1,34.166,0V64a1.75,1.75,0,0,0,3.5,0V44.35A20.606,20.606,0,0,0,64,23.767Z" />
    </svg>
);
